// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle-quantity[data-v-1707d882]{width:28px;height:28px;border-radius:20;display:flex;flex-direction:row;justify-content:center;align-items:center}.group-box[data-v-1707d882]{border:1px solid #dfdfdf;border-radius:10px;padding-bottom:3px;padding-top:3px}", ""]);
// Exports
module.exports = exports;
